import { fallbackHatchColor, HatchSwatch } from './HatchPattern'

const forecastLabel = 'Forecast'

export default function ForecastLabel() {
    return (
        <span>
            <span className="mr-2 inline-flex w-3 justify-center">
                <HatchSwatch color={fallbackHatchColor} />
            </span>
            {forecastLabel}
        </span>
    )
}
